export default [
  {
    header: 'Обратная связь',
  },
  {
    title: 'Статистика отзывов',
    route: 'feedback-stats',
    icon: 'MessageSquareIcon',
    tagVariant: 'light-warning',
  },
]
